module.exports = __webpack_public_path__ + "static/img/icon-complete.0578285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/transport/icon-complete.png
// module id = c5Gl
// module chunks = 1